// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a{cursor:pointer}ul.multiselect__content{max-height:120px}", "",{"version":3,"sources":["webpack://./resources/js/components/PreciosAlquileresCabaComponent.vue"],"names":[],"mappings":"AACA,EACE,cAAF,CAGA,wBACE,gBAAF","sourcesContent":["\na {\n  cursor: pointer;\n}\n\nul.multiselect__content {\n  max-height: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
